import * as React from "react"
import * as styles from "./styles.module.scss"
import Link from "gatsby-link"
import cx from "classnames"
import Tag from "../Tag"

export enum TagsType {
  CATEGORY = "category",
  POST = "post",
}

export interface TagsProps {
  children: React.ReactNode
  type: Type
}

const Tags: React.FC<TagsProps> = ({ children, type }) => {
  return (
    <aside
      className={cx({
        [styles[type]]: true,
      })}
    >
      <ul className={styles.list}>
        <span className={styles.label}>More</span>
        {children}
      </ul>
    </aside>
  )
}

export default Tags
